import React, { useRef, useState } from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';

import './popular.css';

// import required modules
import { EffectCoverflow, Pagination } from 'swiper/modules';

import './popular.css';

const popularData = [
  {
    id:1,
    img: "images/popular1.webp",
    title: "Pangalengan"
  },
  {
    id:2,
    img: "images/popular2.webp",
    title: "Ciwidey"
  },
  {
    id:3,
    img: "images/popular3.webp",
    title: "Bandung"
  }
]


const Popular = () => {
  return (
    

    <section className="section popular" id="destination">
        <article className="data__popular">
          <h1>Top Destination in kota Kembang</h1>
        </article>

        <article className="popular__destination">
        <Swiper 
        effect={'coverflow'}
        grabCursor={true}
        centeredSlides={true}
        slidesPerView={'auto'}
        loop={true}
        spaceBetween={40}
        coverflowEffect={{
          rotate: 0,
        }}
        modules={[EffectCoverflow ,Pagination]} className="mySwiper">
        
          {
            popularData.map((item)=>{
              const {id,img,title} = item;
              return(
                <SwiperSlide key={id} className='popular__card'>
                  <img src={img} alt={title} className='img__popular'/>
                  <div className="popular__detail">
                    <h3 className='popular__title'>{title}</h3>
                    <span>24 tours available</span>
                  </div>
                </SwiperSlide>
              )
              
            })
          }
        
      </Swiper>
      </article>
    </section>
  )
}

export default Popular